export function insertExternalScript(_a) {
    var async = _a.async, dataset = _a.dataset, onError = _a.onError, onLoad = _a.onLoad, src = _a.src, nonce = _a.nonce;
    var script = document.createElement('script');
    if (async)
        script.async = async;
    if (dataset) {
        Object.keys(dataset).map(function (key) {
            script.dataset[key] = dataset[key];
        });
    }
    if (onError)
        script.addEventListener('error', onError);
    if (onLoad)
        script.addEventListener('load', onLoad);
    if (nonce)
        script.setAttribute('nonce', nonce);
    script.src = src;
    document.head.appendChild(script);
}
export function insertInlineScript(_a) {
    var innerHTML = _a.innerHTML, nonce = _a.nonce;
    var script = document.createElement('script');
    if (nonce)
        script.setAttribute('nonce', nonce);
    script.innerHTML = innerHTML;
    document.head.appendChild(script);
}
